import React from 'react';
import PropTypes from 'prop-types';

import { constructMSAImageUrl } from 'helpers';
import { IS_GIFT_CARD } from 'common/regex';
import FavoriteItemPrice from 'components/account/Favorites/FavoriteItemPrice';
import MartyLink from 'components/common/MartyLink';
import css from 'styles/components/account/favoriteItemProduct.scss';

const PRODUCT_IMAGE_SIZE = 280;
const msaImageDimensions = { width: PRODUCT_IMAGE_SIZE, height: PRODUCT_IMAGE_SIZE };

const FavoriteItemProduct = ({ item, oosHearts, onProductClick }, { testId }) => {
  const {
    asin,
    productUrl,
    color,
    size,
    inseam,
    width,
    imageId,
    title,
    brandName,
    productName
  } = item;

  const imagePath = constructMSAImageUrl(imageId, msaImageDimensions);

  return (
    <div className={css.container}>
      <MartyLink
        to={productUrl}
        onClick={onProductClick}
        className={css.mProduct}
        data-test-id={testId('productImage')}>
        <div className={css.image}>
          <img src={imagePath} alt={title} title={title}/>
        </div>
      </MartyLink>
      <div className={css.description}>
        <div className={css.itemContainer}>
          <div className={css.productTitle}>
            <MartyLink
              to={productUrl}
              onClick={onProductClick}
              data-test-id={testId('productTitle')}>
              <div className={css.brandName}>{brandName}</div>
              <div className={css.productName}>{productName}</div>
            </MartyLink>
          </div>
          <div className={css.itemDetails}>
            { (!IS_GIFT_CARD.test(brandName) && color) && <div data-test-id={testId('color')}>Color: {color}</div>}
            {size && <div data-test-id={testId('size')}>Size: {size}</div>}
            {width && <div data-test-id={testId('width')}>Width: {width}</div>}
            {inseam && <div data-test-id={testId('inseam')}>Inseam: {inseam}</div>}
            {asin && <div data-test-id={testId('itemAsin')}>ASIN: {asin}</div>}
          </div>
        </div>
        <FavoriteItemPrice oosHearts={oosHearts} item={item} />
      </div>
    </div>
  );
};

FavoriteItemProduct.contextTypes = {
  testId: PropTypes.func
};

FavoriteItemProduct.propTypes = {
  item: PropTypes.object.isRequired
};

export default FavoriteItemProduct;
